import { requestPayment } from 'Cloud/Application/Payment';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { renderBizMigrationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { getSubscriptionsRequest } from 'reactApp/modules/subscriptions/subscriptions.module';
import { createGaSender, sendGa } from 'reactApp/utils/ga';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

const sendGaSpace = createGaSender('space');

export const useSpaceCallbacks = ({
    isBizUser,
    isSubscriptionsPage,
    countdownPromo,
    isAction,
    isB2BUser,
    isOldBizUser,
    isPaidUser,
    goToSubscriptions,
    isMobile,
}) => {
    const dispatch = useDispatch();

    const sendPaymentRadar = useCallback(
        (label: string) => {
            if (isBizUser || isSubscriptionsPage) {
                return;
            }

            let action = EPaymentGa.space;

            if (countdownPromo) {
                action = EPaymentGa.spaceDiscount;
            } else if (isAction) {
                action = EPaymentGa.spaceAction;
            }

            sendPaymentGa({ action, label });
        },
        [countdownPromo, isAction, isBizUser, isSubscriptionsPage]
    );

    const onShow = useCallback(() => {
        if (!isBizUser) {
            dispatch(getSubscriptionsRequest());
        }

        sendPaymentRadar('view');

        if (!isB2BUser) {
            sendGa('leftColBuyButton', 'show', 'base');
            sendGaSpace('bttn', 'show');
        }
    }, [dispatch, isB2BUser, isBizUser, sendPaymentRadar]);

    const onSubscriptionClick = useCallback(() => goToSubscriptions({ inSameTab: true }), [goToSubscriptions]);

    const onPayment = useCallback(() => {
        if (isOldBizUser) {
            renderBizMigrationDialog();
            return;
        }

        sendGaSpace('bttn', 'click');
        sendPaymentRadar('click');

        if (isMobile) {
            sendGa('leftColBuyButton', 'mobile-click');
            goToSubscriptions({ inSameTab: true });
            return;
        }

        const paymentOptions: { tariff?: string; goToSubscriptions?: () => void } = { goToSubscriptions };

        if (countdownPromo) {
            paymentOptions.tariff = countdownPromo.productId;
        }

        sendGa('leftColBuyButton', 'click');

        if (!isPaidUser) {
            sendGa('spacebar-free-user', 'click');
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        requestPayment({ ...paymentOptions });
    }, [isOldBizUser, sendPaymentRadar, isMobile, countdownPromo, isPaidUser, goToSubscriptions]);

    return {
        onPayment,
        onShow,
        onSubscriptionClick,
    };
};
